import styled from "styled-components";

const PAYMENT_ICON_WIDTH = 36;
const ARROW_ICON_HEIGHT = 11;
const ARROW_ICON_WIDTH = 8;

export const Banner = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.colors[theme.colorMode].positive_Sub,
    padding: `${theme.spacing.xxSmall} ${theme.spacing.empty} ${theme.spacing.xxSmall} ${theme.spacing.medium}`,
    marginBottom: theme.spacing.xxLarge,
    boxShadow: "0px 1px 16px rgba(0, 0, 0, 0.05)",
    borderRadius: `0 0 ${theme.cornerRadius.medium} ${theme.cornerRadius.medium}`,
}));

export const BannerContentContainer = styled.div({
    display: "flex",
    alignItems: "center",
});

export const ArrowIcon = styled.svg(({ theme }) => ({
    stroke: theme.colors[theme.colorMode].positive,
    height: `${ARROW_ICON_HEIGHT}px`,
    width: `${ARROW_ICON_WIDTH}px`,
    color: theme.colors[theme.colorMode].positive,
}));

export const ArrowIconWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    marginRight: theme.spacing.small,
}));

export const Wrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: `${PAYMENT_ICON_WIDTH}px`,
    textAlign: "left",
    alignSelf: "flex-start",
    borderRadius: theme.cornerRadius.rounded,
}));

export const Carousel = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    position: "relative",
    width: "100%",
    flexDirection: "column",
    height: `${PAYMENT_ICON_WIDTH}px`,
    overflow: "hidden",
    borderRadius: theme.cornerRadius.rounded,
}));

export const CarouselStaticItem = styled.div({
    display: "flex",
    alignItems: "center",
    position: "absolute",
    width: "100%",
    opacity: 1,
});

export const CarouselIcon = styled.div({
    width: `${PAYMENT_ICON_WIDTH}px`,
    height: `${PAYMENT_ICON_WIDTH}px`,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

export const CarouselImg = styled.img(({ theme }) => ({
    display: "block",
    maxHeight: "32px",
    width: "auto",
    maxWidth: "100%",
    margin: "auto",
    borderRadius: theme.cornerRadius.rounded,
    listStyle: "none",
}));
